// @core/api/endpoints/document/list_pipelines.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPipelinesResponse,
} from '../../../types/document';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/document';

/**
 * List pipelines
 * Returns available pipeline templates, optionally filtered by document type or status.
 */
export async function ListPipelines(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPipelinesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/document-pipelines`;
  const requestOptions = options;
  return client.get<ListPipelinesResponse>(requestPath, { ...requestOptions, params });
}
